import { ApiClient } from "../api-client";
import { ApiClientError } from "../errors";
import schemaValidators from "./schema-validators";

export default class ScratchNoteClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClient["config"]) {
		super(config, schemaValidators);
	}

	createUploadGrant = async ({
		proctoringSessionUuid,
		mimeType,
	}: {
		proctoringSessionUuid: string;
		mimeType: string;
	}) => {
		try {
			const response = await super.fetch(
				`${this.config.verityOrigin}/api/verity/scratch-note/upload/grant/${proctoringSessionUuid}`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({ mimeType }),
				},
			);
			if (response.ok) {
				const obj: unknown = await response.json();
				if (this.schemaValidators.createUploadGrant.validate(obj)) {
					return obj;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};

	uploadCallback = async ({ scratchNoteId }: { scratchNoteId: string }) => {
		try {
			const response = await super.fetch(
				`${this.config.verityOrigin}/api/verity/scratch-note/upload/callback/${scratchNoteId}`,
				{
					method: "GET",
				},
			);
			if (response.ok) {
				return;
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};

	getLinks = async ({ proctoringSessionUuid }: { proctoringSessionUuid: string }) => {
		try {
			const response = await super.fetch(
				`${this.config.verityOrigin}/api/verity/scratch-note/links/${proctoringSessionUuid}`,
				{
					method: "GET",
				},
			);
			if (response.ok) {
				const obj: unknown = await response.json();
				if (this.schemaValidators.getLinks.validate(obj)) {
					return obj;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};
}
